import { LazyQueryResultTuple, useLazyQuery } from '@apollo/client'
import { ACTIVITY_LIST_DATA } from '../Queries'
import { GetActivityListDataQuery, GetActivityListDataQueryVariables } from '../../../types'

export const useActivityListData = (): LazyQueryResultTuple<GetActivityListDataQuery, GetActivityListDataQueryVariables> => {
  return useLazyQuery<GetActivityListDataQuery, GetActivityListDataQueryVariables>(ACTIVITY_LIST_DATA, {
    fetchPolicy: 'network-only',
  })
}
